import React from 'react';
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";

import reportWebVitals from './ops/reportWebVitals';

import App from './App';

const container = document.getElementsByClassName("body")[0];
const isPrerendered = container.hasChildNodes();

const app = (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      useRefreshTokensFallback={true}
      authorizationParams={{
          redirect_uri: typeof window !== 'undefined' ? window.location.origin : '',
          scope: "openid email",
          audience: process.env.REACT_APP_AUTH0_AUDIENCE
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage">
      <App/>
    </Auth0Provider>
);

if (isPrerendered) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
